// Kinguin returns a generic "_placeholder.png" for products without art.
// Treat it as no image so our own branded placeholder renders instead and
// tiles never pick it as their backdrop.
const PLACEHOLDER = '/_placeholder.';

export function isPlaceholderArt(url: string | null | undefined): boolean {
  return !url || url.includes(PLACEHOLDER);
}

/** Small header/cover image, or null when Kinguin has none. */
export function productCover(p: { coverUrl: string | null; imageUrl: string | null }): string | null {
  if (!isPlaceholderArt(p.coverUrl)) return p.coverUrl;
  if (!isPlaceholderArt(p.imageUrl)) return p.imageUrl;
  return null;
}

/** Large screenshot/banner image (prefers imageUrl), or null. */
export function productArt(p: { coverUrl: string | null; imageUrl: string | null }): string | null {
  if (!isPlaceholderArt(p.imageUrl)) return p.imageUrl;
  if (!isPlaceholderArt(p.coverUrl)) return p.coverUrl;
  return null;
}
